var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMortgageInsurance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_420_2426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3681 19.1153L22.73 19.3026L23.0923 19.1153C23.3189 18.9982 23.5394 18.8718 23.753 18.7372C24.2373 18.4323 24.6872 18.0841 25.0982 17.7005C26.8881 16.0274 27.9449 13.6645 27.9449 11.1442V9.66354C26.7841 9.25851 25.8574 8.35596 25.4201 7.21094H20.0404C19.6031 8.35596 18.6765 9.25851 17.5156 9.66354V11.1442C17.5156 11.3954 17.5259 11.6443 17.5468 11.8916C17.6194 12.7668 17.8198 13.6154 18.133 14.4143C18.914 16.41 20.3989 18.0974 22.3681 19.1153ZM21.0103 11.4223L22.3649 12.7015L24.9074 10.244L26.0486 11.4247L22.3779 14.9725L19.883 12.6162L21.0103 11.4223Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5922 8.08051L15.8739 10.6047V8.49707L16.9758 8.1134C17.2011 8.03479 17.4111 7.92563 17.6017 7.79126L12.592 3.9375L-0.0546875 13.6657L1.9476 16.2687L12.5922 8.08051Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5762 18.0098H13.6601V24.088H11.5762V18.0098Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4977 19.9055C19.2585 19.0579 18.2081 17.9554 17.4222 16.6644C16.6944 15.469 16.2126 14.1462 15.9997 12.7739C15.9997 12.7735 15.9997 12.7735 15.9997 12.7735L12.5922 10.1523L4.68597 16.2338V22.4464H3.11328V24.0883H9.93298V16.3681H15.3009V24.0883H22.0704V22.4464H20.4977V19.9055Z",
    fill: "#8A8A8A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_420_2426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMortgageInsurance);
export default __webpack_public_path__ + "static/media/mortgage-insurance.7a3125303011f60e7433ee606ca90f9c.svg";
export { ForwardRef as ReactComponent };